if (!customElements.get("el-header")) {
  customElements.define("el-header", class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const { signal } = this.events;
      this.section = this.closest(".section-header");
      this.resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty("--header-height", `${this.offsetHeight}px`);
      });
      this.resizeObserver.observe(this);

      // Let the existing search modal and Recharge/cart listeners handle their controls.
      this.addEventListener("click", (event) => {
        if (!event.target.closest(".header__search summary, #cart-icon-bubble")) return;
        const drawer = this.querySelector("header-drawer");
        const details = drawer?.querySelector("details");
        if (details?.open) drawer.closeMenuDrawer(event, details.querySelector("summary"));
      }, { capture: true, signal });

      const cart = this.querySelector("#cart-icon-bubble");
      const cartIcon = cart.querySelector("[data-el-header-cart-icon]").cloneNode(true);
      // Cart section refreshes replace the link contents; keep this header's chosen icon.
      this.cartObserver = new MutationObserver(() => {
        if (cart.querySelector("[data-el-header-cart-icon]")) return;
        const refreshedIcon = cart.querySelector(".svg-wrapper, svg");
        if (refreshedIcon) refreshedIcon.replaceWith(cartIcon.cloneNode(true));
      });
      this.cartObserver.observe(cart, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      const drawer = this.querySelector("header-drawer");
      const details = drawer?.querySelector("details");
      if (details?.open) drawer.closeMenuDrawer(new Event("close"), details.querySelector("summary"));
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.cartObserver?.disconnect();
      this.events = null;
    }
  });
}
